import React from 'react';
import PropTypes from 'prop-types';

class SidebarLeft extends React.Component {
  constructor(props) {
    super(props);

    this.toggleMenu = this.toggleMenu.bind(this);
  }

  getName() {
    return 'SidebarLeft';
  }
  toggleMenu(event) {
    $('html').toggleClass('inner-menu-opened');
  }
  componentDidMount() {
    $('html').removeClass('inner-menu-opened');
  }

  render() {
    return (
      <div className='sidebar-left-container'>

        <div className='inner-menu-toggle'>
          <div
            onClick={this.toggleMenu}
            className='inner-menu-expand'
            data-open='inner-menu'
            >
            { `${ this.props.title || 'Open' }`} <i className='fa fa-chevron-right'></i>
          </div>
        </div>

        <menu id='content-menu' className='inner-menu animated fadeInLeftBig' role='menu'>
          <div className='nano'>
            <div className='nano-content'>
              <div className='inner-menu-toggle-inside'>
                <div onClick={this.toggleMenu} className='inner-menu-collapse'>
                  <i className='fa fa-chevron-up visible-xs-inline'></i><i className='fa fa-chevron-left hidden-xs-inline'></i> { `Hide`}
                </div>
                <div onClick={this.toggleMenu} className='inner-menu-expand' data-open='inner-menu'>
                 { this.props.title || 'Open' }`} <i className='fa fa-chevron-down'></i>
               </div>
              </div>
              <div className='inner-menu-content'>
                {this.props.children}
              </div>
            </div>
          </div>
        </menu>
      </div>
    );
  }
}

SidebarLeft.propTypes = {
  open : PropTypes.bool,
  fixed : PropTypes.bool,
}

export default SidebarLeft;



// WEBPACK FOOTER //
// ./src/browser/components/ui/sidebar-left.js